export const HOUSE_BEDROOM_IDENTIFIERS = [
  'suite',
  'adults_bedroom',
  'children_bedroom',
  'dormitory',
]
export const BEDROOM_BED_IDENTIFIERS = [
  'single_bed',
  'inseparable_double_bed',
  'bunk_bed',
  'single_sofa_bed',
  'double_sofa_bed',
  'two_single_beds',
]

export const isBedroomArea = ({ identifier }: { identifier: string }) =>
  HOUSE_BEDROOM_IDENTIFIERS.includes(identifier)

export const isBedEquipment = ({
  identifier,
  bedSize,
}: {
  identifier: string
  // equipment is a bed if it has a bedSize
  bedSize?: string
}) => Boolean(bedSize || BEDROOM_BED_IDENTIFIERS.includes(identifier))
